<template>
  <div class="CompanyProfile">
    <!-- 公司简介 -->
    <div class="contentBox_header">
      <div class="introduce">
        <div class="introduceleft">
          <ul class="introduceleft_top">
            <li class="about">ABOUT</li>
            <li>关于占东</li>
            <li>ABOUT US</li>
          </ul>
          <div class="introduceleft_center">
            占东科技（成都）有限公司，成立于2025年3月7日，位于成都市青羊区人民南路一段86号城市之心18J，是一家以智能物联与数据分析为核心的高新技术企业。
            公司以农林行业数字化转型为战略起点，专注于虫害、鼠害智能识别感知与防控系统的研发，构建从数据采集、智能分析到智慧防治的全链条技术闭环。依托自主研发的AI算法与物联网平台，公司业务已覆盖智能硬件研发、系统集成、数据服务及运营支持等多个维。核心面向农林行业，为产业链中的各类机构与经营主体提供精准、高效的数字化解决方案，助力其实现林业有害生物的智能化监测、预警与科学防治。并在此基础上进行多元化布局，将成熟的解决方案成功拓展至海关检疫、智慧科普、数字农业及环境监测等相关领域。
          </div>
          <div class="introduceleft_bottom">
            <ul class="boxLeft">
              <li :class="{ animating: isLeftAnimating }">
                {{ animatedLeftCount }}+
              </li>
              <li>
                <div>种</div>
                <div>{{ boxLeft.abilityName }}</div>
              </li>
            </ul>
            <ul class="boxRight">
              <li :class="{ animating: isRightAnimating }">
                {{ animatedRightCount }}+
              </li>
              <li>
                <div>种</div>
                <div>{{ boxRight.abilityName }}</div>
              </li>
            </ul>
          </div>
        </div>

        <div class="introduceright">
          <img src="@/assets/img/aboutUs/gywm_tu1.png" alt="" />
        </div>
      </div>
    </div>


    <div class="map-box">
      <!-- 宣传文案：单独占一行，不参与左右 flex -->
      <div class="map-title">
        立足本地，<span class="highlight">放眼</span>全国，我们的<span class="highlight">业务足迹</span>已遍布<span class="highlight">全国各地</span>
      </div>

      <!-- 左右布局容器：重新启用 flex 实现左右各 50% -->
      <div class="map-content">
        <div class="left-box map-container">
          <img src="@/assets/img/aboutUs/map.png" alt="业务分布地图" />

          <!-- 波纹点标注层 -->
          <div class="map-points-layer">
            <div v-for="point in wavePoints" :key="'wave-' + point.id" class="map-point" :style="{ left: point.left, top: point.top }">
              <div class="wave-point">
                <div class="center-dot"></div>
                <div class="wave-ring"></div>
                <div class="wave-ring wave-ring-delay"></div>
              </div>
            </div>
          </div>

          <!-- 图标标注层 -->
          <div class="map-icons-layer">
            <div v-for="icon in mapIcons" :key="'icon-' + icon.id" class="map-icon" :style="{ left: icon.left, top: icon.top }">
              <img src="@/assets/img/aboutUs/com-icon.png" alt="地图图标" />
            </div>
          </div>

          <!-- 新增：地图图例（左下角） -->
          <div class="map-legend">
            <div class="legend-item">
              <img src="@/assets/img/aboutUs/map-icon.png" alt="项目区域分布图标" />
              <span>项目区域分布</span>
            </div>
            <!--<div class="legend-item">-->
            <!--  <img src="@/assets/img/aboutUs/com-icon.png" alt="公司分布图标" />-->
            <!--  <span>公司分布</span>-->
            <!--</div>-->
          </div>
        </div>

        <div class="right-box">
          <!-- 第一行：图标 + 业务分布 -->
          <div class="distribution-title">
            <img src="@/assets/img/aboutUs/map-icon.png" alt="地图图标" class="title-icon" />
            <span class="title-text">业务分布</span>
          </div>

          <div class="content-box">
            <!-- 第二行：两个数据项左右排列 -->
            <div class="stats-row">
              <img class="stats-bg" src="@/assets/img/aboutUs/right-bj.png" alt="" />
              <div class="stats-content">
                <div class="stat-item">25<span>座城市</span></div>
                <div class="stats-line"></div>
                <div class="stat-item">2000<span>余项目合作</span></div>
              </div>
            </div>

            <!-- 第三行：部分合作单位（加粗） -->
            <div class="section-title">部分合作单位</div>

            <!-- 第四行：合作单位列表 -->
            <div class="org-list">
              东三省林草局 、 云南省林科院 、新疆维吾尔自治区乌鲁木齐市、云南省大理白族自治州、楚雄彝族自治州、临沧市等地 ；大连海关 、宜兴海关、内蒙古鄂尔多斯、宁夏回族自治区中卫沙坡头国家级自然保护区管理局、鄂温克族自治旗林业和草原局、西藏林芝市林业和草原局等等。
            </div>

            <!-- 第五行：院校合作（加粗） -->
            <div class="section-title">院校合作</div>

            <!-- 第六行：院校名单 -->
            <div class="org-list">
              中科院动物所、南开大学、中国农业大学、内蒙古师范大学、东北林业大学、西北林业科技大学等等。
            </div>
          </div>

        </div>

      </div>
    </div>


    <div class="contentBox_fzlc">
      <div class="fzlc_top">
        <ul class="fzlc_topBox">
          <li class="about">Develop</li>
          <li>发展历程</li>
          <li>DEVELOPMENT HISTORY</li>
        </ul>
      </div>
      <div class="fzlc_bottom">
        <div class="fzlc_bottomBox">
          <!-- 独立的水平线 -->
          <div class="global-horizontal-line"></div>

          <!-- 轮播容器 - 整体移动 -->
          <div
            class="timeline-carousel"
            :style="{ transform: `translateX(${boxPosition}px)` }"
          >
            <!-- 每个年份的完整组合（年份+圆点+连接线+卡片） -->
            <div
              class="timeline-item-complete"
              v-for="(item, index) in DHArr"
              :key="item.id"
            >
              <!-- 年份显示 -->
              <div class="year-display">{{ item.year }}</div>

              <!-- 圆点组 -->
              <div class="circle-group">
                <div class="circle-outer"></div>
                <div class="circle-inner"></div>
              </div>

              <!-- 垂直连接线 -->
              <div class="vertical-line"></div>

              <!-- 时间轴卡片 -->
              <div class="timeline-card">
                <div class="card-content">
                  <!-- 自定义时间轴 - 不使用Element UI -->
                  <div class="custom-timeline">
                    <!-- 时间轴主线条 -->
                    <div class="timeline-line"></div>
                    <div
                      class="timeline-item"
                      v-for="(activity, actIndex) in item.activities"
                      :key="activity.id"
                    >
                      <!-- 月份 -->
                      <div class="timeline-month">
                        {{ activity.timestamp.slice(5, 7) }}月
                      </div>
                      <!-- 圆点 -->
                      <div class="timeline-dot"></div>
                      <!-- 内容 -->
                      <div class="timeline-content">{{ activity.content }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bottomBox_btnLeft" @click="moveBox_l"><</div>
        <div class="bottomBox_btnRight" @click="moveBox_r">></div>
      </div>
    </div>
    <div class="contentBox_foot">
      <div class="contentBox_footBox">
        <div class="footBox_top">
          <ul class="topLeft">
            <li class="about">Expert</li>
            <li>专家团队</li>
            <li>EXPERT TEAM</li>
          </ul>
          <ul class="topRight">
            <li>
              优秀的专家鉴定团队
            </li>
            <li>
              团队由占东科技（成都）有限公司和中国知名大学东北林业大学林学院森林保护专业教授、博士生导师与北京林业大学农学博士、中国林业科学研究院工程师共同组建。负责系统中昆虫数据库的建立，包括昆虫分类标准、昆虫图片鉴定及昆虫生活史。
            </li>
          </ul>
        </div>
        <div class="footBox_bottom">
          <!-- 专家轮播容器 -->
          <div
            class="expert-carousel-container"
            @mouseenter="stopExpertAutoPlay"
            @mouseleave="resumeExpertAutoPlay"
          >
            <!-- 专家展示区域 -->
            <div class="expert-display-area">
              <ul
                class="item"
                v-for="(item, index) in currentExpertPage"
                :key="item.id"
                @click="personStyleChange(item.id)"
                :class="[
                  personId === item.id ? 'active' : '',
                  item.isPlaceholder ? 'placeholder' : ''
                ]"
              >
                <!-- 真实专家数据 -->
                <template v-if="!item.isPlaceholder">
                  <li>
                    <img :src="item.expertImgUrl" alt="" />
                  </li>
                  <li class="text_bottom">
                    <div
                      class="text_bottom_box1"
                      :class="[personId === item.id ? 'active' : '']"
                    >
                      {{ item.expertName }}
                    </div>
                    <div
                      class="text_bottom_box2"
                      :class="[personId === item.id ? 'active' : '']"
                    >
                      {{ item.expertBelong }} | {{ item.expertTitle }}
                    </div>
                    <div class="text_bottom_img" v-show="personId === item.id">
                      <img src="@/assets/img/aboutUs/gywm_xl.png" alt="" />
                    </div>
                  </li>
                </template>

                <!-- 空白占位项 -->
                <template v-else>
                  <li class="placeholder-image">
                    <div class="placeholder-content"></div>
                  </li>
                  <li class="text_bottom placeholder-text">
                    <div class="text_bottom_box1"></div>
                    <div class="text_bottom_box2"></div>
                  </li>
                </template>
              </ul>
            </div>

            <!-- 轮播导航点 -->
            <div class="expert-carousel-dots" v-if="totalExpertPages > 1">
              <span
                v-for="(page, index) in totalExpertPages"
                :key="index"
                :class="['dot', { active: currentExpertPageIndex === index }]"
                @click="goToExpertPage(index)"
              ></span>
            </div>

            <!-- 轮播箭头 -->
            <div class="expert-carousel-arrows" v-if="totalExpertPages > 1">
              <div
                class="arrow arrow-left"
                @click="prevExpertPage"
                :class="{ disabled: currentExpertPageIndex === 0 }"
              >
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <path
                    d="M10 12L6 8l4-4"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
              </div>
              <div
                class="arrow arrow-right"
                @click="nextExpertPage"
                :class="{
                  disabled: currentExpertPageIndex === totalExpertPages - 1
                }"
              >
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <path
                    d="M6 4l4 4-4 4"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecognitionCapability from "@/api/recognitionCapability.js";
import DevelopmentHistory from "@/api/developmentHistory.js";
import ExpertTeam from "@/api/expertTeam.js";
export default {
  name: "CompanyProfile",
  data() {
    return {
      personId: "01",
      boxPosition: 0,
      boxLeft: {},
      boxRight: {},
      //发展历程
      DHArr: [],
      //专家团队
      expertTeamArr: [],
      // 动画相关数据
      animatedLeftCount: 0,
      animatedRightCount: 0,
      animationDuration: 2000, // 动画持续时间(毫秒)
      isLeftAnimating: false,
      isRightAnimating: false,
      currentExpertPage: [],
      totalExpertPages: 0,
      currentExpertPageIndex: 0,
      expertAutoPlay: false, // 是否自动轮播
      // 新增地图闪闪
      expertAutoPlayTimer: null, // 自动轮播定时器
      personId: "01",
      boxPosition: 0,
      boxLeft: {},
      boxRight: {},
      DHArr: [],
      expertTeamArr: [],
      animatedLeftCount: 0,
      animatedRightCount: 0,
      animationDuration: 2000,
      isLeftAnimating: false,
      isRightAnimating: false,
      currentExpertPage: [],
      totalExpertPages: 0,
      currentExpertPageIndex: 0,
      expertAutoPlay: false,
      expertAutoPlayTimer: null,

      // 项目区域分布（波纹闪烁点）- 共14个
      wavePoints: [
        { id: 1, left: '20%', top: '30%', city: '新疆' },       // 新疆
        { id: 2, left: '18%', top: '50%', city: '西藏' },       // 西藏
        { id: 3, left: '33%', top: '46%', city: '青海' },       // 青海
        { id: 4, left: '56%', top: '38%', city: '内蒙古' },     // 内蒙古
        { id: 5, left: '44%', top: '65%', city: '四川' },       // 四川
        { id: 6, left: '42%', top: '80%', city: '云南' },       // 云南
        { id: 7, left: '58%', top: '57%', city: '陕西' },       // 陕西
        { id: 8, left: '65%', top: '63%', city: '湖北' },       // 湖北
        { id: 9, left: '80%', top: '60%', city: '江苏' },       // 江苏
        { id: 10, left: '72%', top: '39%', city: '北京' },      // 北京
        { id: 11, left: '74%', top: '41%', city: '天津' },      // 天津
        { id: 12, left: '86%', top: '35%', city: '辽宁' },      // 辽宁
        { id: 13, left: '91%', top: '28%', city: '吉林' },      // 吉林
        { id: 14, left: '88%', top: '16%', city: '黑龙江' },    // 黑龙江
      ],

      // // 公司分布（静态图标）- 共7个
      // mapIcons: [
      //   { id: 1, left: '25%', top: '30%', city: '新疆' },       // 新疆
      //   { id: 2, left: '60%', top: '38%', city: '内蒙古' },     // 内蒙古
      //   { id: 3, left: '72%', top: '36%', city: '北京' },       // 北京
      //   { id: 4, left: '51%', top: '64%', city: '四川' },       // 四川（成都位置）
      //   { id: 5, left: '46%', top: '78%', city: '云南' },       // 云南
      //   { id: 6, left: '85%', top: '25%', city: '吉林' },       // 吉林
      //   { id: 7, left: '86%', top: '14%', city: '黑龙江' },     // 黑龙江
      // ],
    };
  },
  computed: {
    // 删除不再需要的年份计算，因为现在每个项目都有自己的年份显示
  },
  methods: {
    // 页面数据加载方法（供路由守卫后调用）
    async loadAllPageData() {
      // 并行加载所有数据
      await Promise.all([
        this.getRCList(),
        this.getDHList(),
        this.getExpertTeamList()
      ]);
    },

    personStyleChange(id) {
      // 确保只处理真实专家的点击，不处理占位项
      const expert = this.currentExpertPage.find(
        item => item.id === id && !item.isPlaceholder
      );
      if (expert) {
        this.personId = id;
      }
    },
    moveBox_l() {
      const moveDistance = 424; // 390px(宽度) + 34px(间距)
      this.boxPosition += moveDistance;
      if (this.boxPosition > 0) {
        this.boxPosition = 0;
      }
    },
    moveBox_r() {
      const moveDistance = 424; // 390px(宽度) + 34px(间距)
      const maxLeft = -moveDistance * (this.DHArr.length - 3); // 显示3个项目
      this.boxPosition -= moveDistance;
      if (this.boxPosition < maxLeft) {
        this.boxPosition = maxLeft;
      }
    },
    //获取识别能力
    async getRCList() {
      const params = {
        page: 1,
        pageSize: 10
      };
      const { code, msg, data, total } = await RecognitionCapability.queryList(
        params
      );
      if (code === 200) {
        if (data.length > 0) {
          this.boxLeft = data[0];
        }
        if (data.length > 1) {
          this.boxRight = data[1];
        }
        // 获取数据后设置交集观察器
        this.$nextTick(() => {
          this.setupIntersectionObserver();
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 设置交集观察器
    setupIntersectionObserver() {
      const numberSection = document.querySelector(".introduceleft_bottom");
      if (!numberSection) return;

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // 当元素进入视口时启动动画
              this.startCountAnimation();
              // 动画开始后移除观察器，避免重复触发
              observer.unobserve(numberSection);
            }
          });
        },
        {
          threshold: 0.5, // 当50%的元素进入视口时触发
          rootMargin: "0px 0px -50px 0px" // 提前一点触发
        }
      );

      observer.observe(numberSection);
    },
    //发展历程
    async getDHList() {
      const params = {
        // startStatus: 1,
        startTime: "",
        endTime: "",
        page: 1,
        pageSize: 50
      };
      const { code, msg, data, total } = await DevelopmentHistory.queryList(
        params
      );
      if (code === 200) {
        if (data.length > 0) {
          // 过滤enabled为1的数据
          const filteredData = data.filter(item => item.enabled === 1);

          const groupedMap = filteredData.reduce((map, item) => {
            const year = item.developmentDate.slice(0, 4);
            if (!map.has(year)) map.set(year, { year, activities: [] });
            map.get(year).activities.push(item);
            return map;
          }, new Map());

          // 年份降序排序（2025 → 2023 → 2021）
          this.DHArr = Array.from(groupedMap.values())
            .sort((a, b) => b.year - a.year)
            .map((group, index) => ({
              id: (index + 1).toString().padStart(3, "0"),
              year: group.year,
              // 活动按月升序排序（1月→4月）
              activities: group.activities
                .sort((a, b) =>
                  a.developmentDate.localeCompare(b.developmentDate)
                )
                .map((item, idx) => ({
                  id: item.id,
                  content: item.content,
                  timestamp: item.developmentDate
                }))
            }));
        }
      } else {
        this.$message.error(msg);
      }
    },
    async getExpertTeamList() {
      const params = {
        // startStatus: 1,
        expertName: "", //专家名称
        startTime: "",
        endTime: "",
        page: 1,
        pageSize: 20 // 增加页面大小以支持更多专家数据
      };
      const { code, msg, data, total } = await ExpertTeam.queryList(params);
      if (code === 200) {
        if (data.length > 0) {
          // 过滤enable为1的数据
          const filteredData = data.filter(item => item.enable === 1);

          this.expertTeamArr = filteredData;
          if (this.expertTeamArr.length > 0) {
            this.personId = this.expertTeamArr[0].id;
          }
          // 计算总页数和初始化当前页面数据
          this.totalExpertPages = Math.ceil(this.expertTeamArr.length / 4);
          const initialPageData = this.expertTeamArr.slice(0, 4);
          this.currentExpertPage = this.fillExpertPageWithPlaceholders(
            initialPageData
          );

          // 如果开启自动轮播且有多页数据
          if (this.expertAutoPlay && this.totalExpertPages > 1) {
            this.startExpertAutoPlay();
          }
        }
      }
    },
    // 启动数字动画
    startCountAnimation() {
      // 左侧数字动画
      if (this.boxLeft.innerCount) {
        this.isLeftAnimating = true;
        this.animateNumber(
          0,
          this.boxLeft.innerCount,
          this.animationDuration,
          value => {
            this.animatedLeftCount = value;
          },
          () => {
            this.isLeftAnimating = false;
          }
        );
      }

      // 右侧数字动画
      if (this.boxRight.innerCount) {
        // 稍微延迟启动右侧动画，创造层次感
        setTimeout(() => {
          this.isRightAnimating = true;
          this.animateNumber(
            0,
            this.boxRight.innerCount,
            this.animationDuration,
            value => {
              this.animatedRightCount = value;
            },
            () => {
              this.isRightAnimating = false;
            }
          );
        }, 300);
      }
    },

    // 数字递增动画方法
    animateNumber(start, end, duration, callback, onComplete) {
      const startTime = performance.now();
      const animate = currentTime => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 使用缓动函数，让动画更平滑
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const currentValue = Math.floor(start + (end - start) * easeOutQuart);

        callback(currentValue);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // 动画完成回调
          if (onComplete) onComplete();
        }
      };
      requestAnimationFrame(animate);
    },

    // 补充空白占位项到4个的方法
    fillExpertPageWithPlaceholders(expertData) {
      const filledData = [...expertData];
      const placeholdersNeeded = 4 - expertData.length;

      for (let i = 0; i < placeholdersNeeded; i++) {
        filledData.push({
          id: `placeholder_${i}`,
          expertName: "",
          expertBelong: "",
          expertTitle: "",
          expertImgUrl: "",
          isPlaceholder: true
        });
      }

      return filledData;
    },

    goToExpertPage(index) {
      this.currentExpertPageIndex = index;
      const start = index * 4;
      const pageData = this.expertTeamArr.slice(start, start + 4);

      // 如果当前页数据不足4个，补充空白占位项
      this.currentExpertPage = this.fillExpertPageWithPlaceholders(pageData);

      // 设置当前页面第一个非占位专家为选中状态
      const firstRealExpert = this.currentExpertPage.find(
        expert => !expert.isPlaceholder
      );
      if (firstRealExpert) {
        this.personId = firstRealExpert.id;
      }

      // 用户手动操作时，重新开始自动轮播
      if (this.expertAutoPlay && this.totalExpertPages > 1) {
        this.startExpertAutoPlay();
      }
    },
    prevExpertPage() {
      if (this.currentExpertPageIndex > 0) {
        this.currentExpertPageIndex--;
        this.goToExpertPage(this.currentExpertPageIndex);
      }
    },
    nextExpertPage() {
      if (this.currentExpertPageIndex < this.totalExpertPages - 1) {
        this.currentExpertPageIndex++;
        this.goToExpertPage(this.currentExpertPageIndex);
      }
    },
    startExpertAutoPlay() {
      // 清除之前的定时器
      if (this.expertAutoPlayTimer) {
        clearInterval(this.expertAutoPlayTimer);
      }

      // 设置自动轮播，每5秒切换一次
      this.expertAutoPlayTimer = setInterval(() => {
        if (this.currentExpertPageIndex < this.totalExpertPages - 1) {
          this.nextExpertPage();
        } else {
          // 回到第一页
          this.goToExpertPage(0);
        }
      }, 5000);
    },
    stopExpertAutoPlay() {
      if (this.expertAutoPlayTimer) {
        clearInterval(this.expertAutoPlayTimer);
        this.expertAutoPlayTimer = null;
      }
    },
    resumeExpertAutoPlay() {
      if (this.expertAutoPlay && this.totalExpertPages > 1) {
        this.startExpertAutoPlay();
      }
    }
  },
  mounted() {
    // 路由守卫已经确保token存在，直接加载数据
    this.loadAllPageData();
  },
  beforeDestroy() {
    // 清理定时器
    this.stopExpertAutoPlay();
  }
};
</script>
<!-- contentBoxRef -->
<style scoped lang="scss">
.CompanyProfile {
  width: 100%;
  //   padding-top: 40px;
  .contentBox_header {
    width: 100%;
    height: 818px;
    background: url("../../../assets/img/aboutUs/gywm_d1.png") no-repeat;
    background-size: 100% 818px;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .introduce {
      width: 100%;
      height: 650px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding-left: 280px;
      padding-right: 20px;
      margin-top: 120px;
      gap: 20px;

      // 响应式布局
      @media (max-width: 1400px) {
        padding-left: 100px;
        padding-right: 50px;
      }

      @media (max-width: 1024px) {
        flex-direction: column;
        height: auto;
        padding: 20px;
        margin-top: 50px;
        align-items: center;
      }

      @media (max-width: 768px) {
        padding: 10px;
        margin-top: 30px;
      }
      .introduceleft {
        width: 612px;
        height: 650px;

        @media (max-width: 1400px) {
          width: 500px;
        }

        @media (max-width: 1024px) {
          width: 100%;
          height: auto;
          max-width: 600px;
        }
        .introduceleft_top {
          width: 100%;
          height: 142px;
          position: relative;
          li {
            &:nth-child(1) {
              width: 100%;
              height: 90px;
              color: #eeeeee;
              font-size: 108px;
              position: relative;
              font-family: Impact;
              opacity: 0.7;
              &:after {
                content: "";
                width: 60px;
                height: 4px;
                background-color: #bdbdbd;
                position: absolute;
                left: -6px;
                top: 46px;
              }
            }
            &:nth-child(2) {
              width: 144px;
              height: 48px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 36px;
              color: #333333;
              position: absolute;
              top: 68px;
              left: 0;
            }
            &:nth-child(3) {
              width: 144px;
              height: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 16px;
              color: #a9a9a9;
              position: absolute;
              top: 116px;
              left: 0;
            }
          }
        }
        .introduceleft_center {
          width: 100%;
          height: 208px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #454545;
          line-height: 32px;
          text-indent: 20px;
          margin-top: 40px;
          overflow: auto;
        }
        .introduceleft_bottom {
          width: 100%;
          height: 60px;
          margin-top: 72px;
          display: flex;
          justify-content: space-between;
          .boxLeft {
            width: 300px;
            height: 60px;
            display: flex;

            li {
              &:nth-child(1) {
                width: 160px;
                height: 60px;
                font-family: Impact;
                font-weight: 400;
                font-size: 60px;
                color: #383838;
                transition: all 0.3s ease;

                &.animating {
                  color: #1c7e28;
                  transform: scale(1.05);
                  text-shadow: 0 0 10px rgba(28, 126, 40, 0.3);
                }
              }
              &:nth-child(2) {
                flex: 1;
                font-size: 18px;
                padding: 14px 0 0 14px;
              }
            }
          }
          .boxRight {
            width: 300px;
            height: 60px;
            display: flex;

            li {
              &:nth-child(1) {
                width: 160px;
                height: 60px;
                font-family: Impact;
                font-weight: 400;
                font-size: 60px;
                color: #383838;
                transition: all 0.3s ease;

                &.animating {
                  color: #1c7e28;
                  transform: scale(1.05);
                  text-shadow: 0 0 10px rgba(28, 126, 40, 0.3);
                }
              }
              &:nth-child(2) {
                flex: 1;
                font-size: 18px;
                padding: 14px 0 0 14px;
              }
            }
          }
        }
      }
      .introduceright {
        width: 947px;
        height: 650px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          transition: transform 0.3s ease;

          &:hover {
            transform: scale(1.02);
          }
        }

        // 响应式适配
        @media (max-width: 1400px) {
          width: calc(100vw - 520px);
          max-width: 800px;
        }

        @media (max-width: 1024px) {
          width: 100%;
          height: 400px;
          margin-top: 20px;
        }

        @media (max-width: 768px) {
          height: 300px;
        }
      }
    }
  }
  .contentBox_fzlc {
    width: 100%;
    height: 920px; /* 增加高度以匹配内容增加 */
    border: 1px solid transparent;
    background: url("../../../assets/img/aboutUs/gywm_bj3.png") no-repeat;
    background-size: 100% 720px;
    padding-top: 150px;
    .fzlc_top {
      width: 100%;
      height: 144px;

      .fzlc_topBox {
        width: 360px;
        height: 144px;
        margin: 0 auto;
        position: relative;
        li {
          &:nth-child(1) {
            width: 100%;
            height: 90px;
            color: #b3ccba;
            font-size: 108px;
            position: relative;
            font-family: Impact;
            opacity: 0.7;
            &:after {
              content: "";
              width: 54px;
              height: 4px;
              background-color: #edebeb;
              position: absolute;
              left: -14px;
              top: 46px;
            }
          }
          &:nth-child(2) {
            width: 144px;
            height: 48px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #fff;
            position: absolute;
            top: 76px;
            left: 50%;
            margin-left: -72px;
          }
          &:nth-child(3) {
            width: 204px;
            height: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #fff;
            position: absolute;
            top: 124px;
            left: 50%;
            margin-left: -102px;
          }
        }
      }
    }
    .fzlc_bottom {
      width: 100%;
      height: 530px; /* 增加高度以容纳重新定位的内容 */
      padding: 0 280px;
      margin-top: 81px; /* 增加顶部边距，为年份显示留空间 */
      position: relative;
      .fzlc_bottomBox {
        width: 100%;
        height: 530px; /* 增加高度以容纳重新定位的内容 */
        position: relative;
        overflow: hidden; /* 重新添加overflow隐藏超出部分 */

        /* 独立的整体水平线 */
        .global-horizontal-line {
          position: absolute;
          top: 104px; /* 调整以匹配新的圆点组位置 (86px + 18px圆点中心) */
          left: -50px; /* 调整为适度延伸 */
          right: -50px; /* 调整为适度延伸 */
          height: 2px;
          background-color: #ffffff;
          opacity: 0.6;
          z-index: 1;
        }

        /* 轮播容器 */
        .timeline-carousel {
          display: flex;
          transition: transform 0.5s ease;
          height: 100%;
        }

        /* 每个完整的时间轴项目 */
        .timeline-item-complete {
          width: 390px;
          min-width: 390px;
          height: 100%;
          margin-right: 34px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;

          /* 年份显示 */
          .year-display {
            position: absolute;
            top: 40px; /* 调整到容器内部 */
            left: 30%; /* 用户调整的位置 */
            transform: translateX(-50%);
            font-family: Source Han Sans CN;
            font-weight: 700;
            font-size: 35px;
            color: #ffffff;
            z-index: 3;
            white-space: nowrap;
          }

          /* 圆点组 */
          .circle-group {
            position: absolute;
            top: 86px; /* 相应调整圆点组位置 */
            left: 30%; /* 用户调整的位置 */
            transform: translateX(-50%);
            z-index: 2;

            .circle-outer {
              width: 36px;
              height: 36px;
              background: #ffffff;
              border-radius: 50%;
              opacity: 0.28;
              position: relative;
            }

            .circle-inner {
              width: 11px;
              height: 11px;
              background: #ffffff;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 1;
            }
          }

          /* 垂直连接线 - 从圆圈到卡片，并与卡片内时间轴对接 */
          .vertical-line {
            position: absolute;
            top: 117px; /* 调整以匹配新的圆点组位置 (86px + 36px圆点高度) */
            left: 30%;
            transform: translateX(-50%);
            width: 2px;
            height: 2px;
            background: #1c7e28;
            z-index: 1;
          }

          /* 时间轴卡片 */
          .timeline-card {
            position: absolute;
            top: 166px; /* 调整以匹配新的垂直线位置 (122px + 44px) */
            left: 0;
            width: 390px;
            height: 322px;
            background: #ffffff;
            box-shadow: 0px 4px 23px 1px rgba(48, 112, 57, 0.11);
            border-radius: 10px;

            .card-content {
              width: 100%;
              height: 100%;
              padding: 20px;
              overflow-y: auto;

              /* 自定义滚动条 */
              &::-webkit-scrollbar {
                width: 4px;
              }

              &::-webkit-scrollbar-track {
                background: #f8f8f8;
                border-radius: 2px;
              }

              &::-webkit-scrollbar-thumb {
                background: #1c7e28;
                border-radius: 2px;

                &:hover {
                  background: #15621f;
                }
              }

              /* 自定义时间轴样式 - 根据用户调整的位置 */
              .custom-timeline {
                margin: 0;
                padding: 15px 0;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;

                /* 时间轴主线条 - 用户调整的位置 */
                .timeline-line {
                  position: absolute;
                  left: 27.85%; /* 用户调整的位置 */
                  transform: translateX(-50%);
                  top: -20px;
                  bottom: 0;
                  width: 2px;
                  background: #1c7e28;
                  border-radius: 1px;
                  z-index: 1;
                }

                .timeline-item {
                  margin-bottom: 25px; /* 恢复正常间距 */
                  position: relative;
                  display: flex;
                  align-items: flex-start;
                  min-height: auto; /* 让高度自适应内容 */
                  width: 100%;

                  &:last-child {
                    margin-bottom: 0;
                  }

                  /* 月份 - 绝对定位在左侧 */
                  .timeline-month {
                    position: absolute;
                    left: calc(25% - 0.45rem); /* 用户调整的位置 */
                    top: 8px;
                    width: 30px;
                    font-family: Source Han Sans CN;
                    font-weight: 700;
                    font-size: 14px;
                    color: #333333;
                    text-align: center;
                    z-index: 2;
                    white-space: nowrap;
                  }

                  /* 圆点 - 绝对定位在时间轴线上 */
                  .timeline-dot {
                    position: absolute;
                    left: 27.85%; /* 用户调整的位置 */
                    top: 8px;
                    transform: translateX(-50%);
                    width: 14px;
                    height: 14px;
                    background-color: #fff;
                    border: 2px solid #ffffff;
                    border-radius: 50%;
                    z-index: 2;
                    box-shadow: 0 0 0 1px #1c7e28;
                  }

                  /* 内容区域 - 使用正常文档流 */
                  .timeline-content {
                    margin-left: 30%; /* 左边距为时间轴留出空间 */
                    padding-left: 10px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 28px;
                    text-align: left;
                    word-break: break-all;
                    flex: 1; /* 占用剩余空间 */
                  }
                }
              }
            }
          }
        }

        /* 删除旧的样式规则 */
        .bottomBox_line,
        .circleBox1Out,
        .circleBox1,
        .smallCircleBox1,
        .circleBox2Out,
        .circleBox2,
        .smallCircleBox2,
        .circleBox3Out,
        .circleBox3,
        .smallCircleBox3,
        .connection-line-1,
        .connection-line-2,
        .connection-line-3,
        .carousel-container,
        .item {
          display: none;
        }
      }
      .bottomBox_btnLeft {
        width: 46px;
        height: 46px;
        background-color: #fff;
        font-size: 36px;
        color: #1c7e28;
        border-radius: 50%;
        padding-left: 6px;
        padding-top: 4px;
        position: absolute;
        top: 80px;
        left: 233px;
        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }
      }
      .bottomBox_btnRight {
        width: 46px;
        height: 46px;
        background-color: #fff;
        font-size: 36px;
        color: #1c7e28;
        border-radius: 50%;
        padding-left: 12px;
        padding-top: 4px;
        position: absolute;
        top: 80px;
        right: 234px;
        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }
      }
    }
  }
  .contentBox_foot {
    width: 100%;
    height: 974px;
    padding: 0 280px;
    background: url("../../../assets/img/aboutUs/gywm_bj4.png") no-repeat;
    background-size: 100% 974px;
    margin-top: 108px;
    .contentBox_footBox {
      width: 100%;
      height: 974px;
      .footBox_top {
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: space-between;
        .topLeft {
          width: 360px;
          height: 150px;
          position: relative;
          li {
            &:nth-child(1) {
              width: 100%;
              height: 90px;
              color: #efefef;
              font-size: 108px;
              position: relative;
              font-family: Impact;
              opacity: 0.7;
              &:after {
                content: "";
                width: 60px;
                height: 4px;
                background-color: #d4d4d4;
                position: absolute;
                left: -8px;
                top: 44px;
              }
            }
            &:nth-child(2) {
              width: 144px;
              height: 48px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 36px;
              color: #323232;
              position: absolute;
              top: 86px;
              left: 0;
            }
            &:nth-child(3) {
              width: 204px;
              height: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 16px;
              color: #c8c8c8;
              position: absolute;
              top: 130px;
              left: 0;
            }
          }
        }
        .topRight {
          width: 674px;
          height: 150px;
          background: url("../../../assets/img/aboutUs/gywm_bt4.png") no-repeat;
          background-size: 100px 68px;
          background-position: 96% 3%;
          padding-top: 10px;
          li {
            &:nth-child(1) {
              width: 198px;
              height: 22px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 22px;
              color: #333333;
              line-height: 38px;
            }
            &:nth-child(2) {
              width: 667px;
              height: 90px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #666666;
              line-height: 30px;
              margin-top: 20px;
              overflow: auto;
            }
          }
        }
      }
      .footBox_bottom {
        width: 100%;
        height: 540px; // 增加高度以容纳导航点
        margin-top: 150px;

        .expert-carousel-container {
          width: 100%;
          height: 100%;
          position: relative;

          .expert-display-area {
            width: 100%;
            height: 480px;
            display: flex;
            justify-content: space-between;

            .item {
              width: 310px;
              height: 480px;
              position: relative;
              display: flex;
              flex-direction: column;
              transition: all 0.3s ease;

              &:hover {
                cursor: pointer;
                transform: translateY(-2px);
              }

              li {
                &:nth-child(1) {
                  width: 100%;
                  height: 408px;
                  img {
                    width: 100%;
                    height: 408px;
                    object-fit: cover;
                    border-radius: 8px 8px 0 0;
                  }
                }
              }

              .text_bottom {
                flex: 1;
                padding-left: 6px;
                position: relative;
                background: #fff;
                border-radius: 0 0 8px 8px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

                .text_bottom_box1 {
                  width: 100%;
                  height: 18px;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 18px;
                  color: #333333;
                  line-height: 28px;
                  margin-top: 10px;
                }

                .text_bottom_box2 {
                  width: 100%;
                  height: 10px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #666666;
                  line-height: 28px;
                  margin-top: 10px;
                }

                .text_bottom_img {
                  width: 24px;
                  height: 13px;
                  position: absolute;
                  top: 28px;
                  left: 268px;
                }
              }

              .active {
                color: #fff !important;
                &:before {
                  content: "";
                  width: 1px;
                  height: 38px;
                  background-color: #fff;
                  position: absolute;
                  top: 20px;
                  left: 252px;
                }
              }

              &.active {
                margin-top: -34px;
                background-color: #1c7e28;
                color: #fff !important;
                transition: all 0.5s;
                border-radius: 8px;

                &:before {
                  width: 100%;
                  height: 4px;
                  content: "";
                  background-color: #1c7e28;
                  position: absolute;
                  top: 0;
                  left: 0;
                  border-radius: 8px 8px 0 0;
                }

                .text_bottom {
                  background-color: #1c7e28;
                  color: #fff;
                  border-radius: 0 0 8px 8px;

                  .text_bottom_box1,
                  .text_bottom_box2 {
                    color: #fff;
                  }
                }
              }

              // 空白占位项样式
              &.placeholder {
                opacity: 0;
                pointer-events: none;
                cursor: default;

                .placeholder-image {
                  width: 100%;
                  height: 408px;

                  .placeholder-content {
                    width: 100%;
                    height: 408px;
                    background: transparent;
                    border-radius: 8px 8px 0 0;
                  }
                }

                .placeholder-text {
                  background: transparent;
                  box-shadow: none;

                  .text_bottom_box1,
                  .text_bottom_box2 {
                    background: transparent;
                    height: 18px;
                  }
                }

                &:hover {
                  transform: none;
                  cursor: default;
                }
              }
            }
          }

          .expert-carousel-dots {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            gap: 8px;

            .dot {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #ccc;
              cursor: pointer;
              transition: all 0.3s ease;

              &:hover {
                background-color: #999;
              }

              &.active {
                background-color: #1c7e28;
                transform: scale(1.2);
              }
            }
          }

          .expert-carousel-arrows {
            .arrow {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              width: 40px;
              height: 40px;
              background-color: rgba(255, 255, 255, 0.9);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.3s ease;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              z-index: 10;

              &:hover {
                background-color: #1c7e28;
                color: white;
                transform: translateY(-50%) scale(1.1);
              }

              &.disabled {
                opacity: 0.5;
                cursor: not-allowed;

                &:hover {
                  background-color: rgba(255, 255, 255, 0.9);
                  color: inherit;
                  transform: translateY(-50%);
                }
              }

              &.arrow-left {
                left: -20px;
              }

              &.arrow-right {
                right: -20px;
              }

              svg {
                width: 16px;
                height: 16px;
                color: #666;
                transition: color 0.3s ease;
              }

              &:hover svg {
                color: white;
              }

              &.disabled svg {
                color: #ccc;
              }
            }
          }
        }
      }
    }
  }

  .map-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 80px;
    margin: 60px 0;
    box-sizing: border-box;

    .map-title {
      text-align: center;
      font-size: 32px;
      font-weight: 500;
      color: #333333;
      line-height: 1.4;
      margin-bottom: 48px;
      width: 100%;

      .highlight {
        color: #1d7e29;
        font-size: 38px;
        font-weight: 600;
      }
    }

    .map-content {
      display: flex;
      width: 100%;
      gap: 30px;
    }

    .left-box,
    .right-box {
      flex: 0 0 50%;
      width: 50%;
      box-sizing: border-box;
    }

    // 左侧地图
    .left-box {
      position: relative;
      overflow: visible;

      img {
        width: 100%;
        height: auto;
        display: block;
        border-radius: 8px;
        object-fit: cover;
      }

      .map-legend {
        position: absolute;
        bottom: 20px;
        left: 20px;
        background: transparent;
        backdrop-filter: none;
        padding: 0;
        z-index: 30;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .legend-item {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #333333;
          font-size: 20px;
          font-weight: 500;
          line-height: 1.2;
          white-space: nowrap;

          img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            display: block;
          }
        }
      }

      // 点标注层
      .map-points-layer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      }

      .map-point {
        position: absolute;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }

      // 普通闪烁点
      .blink-dot {
        width: 10px;
        height: 10px;
        background-color: #4ade80;
        border-radius: 50%;
        box-shadow: 0 0 6px rgba(74, 222, 128, 0.8);
        animation: blink-animation 1.5s ease-in-out infinite;

        &::after {
          content: '';
          position: absolute;
          top: -4px;
          left: -4px;
          right: -4px;
          bottom: -4px;
          border-radius: 50%;
          background: rgba(74, 222, 128, 0.3);
          animation: pulse-ring 1.5s ease-out infinite;
        }
      }

      // 中心波纹点
      .wave-point {
        position: relative;
        width: 12px;
        height: 12px;

        .center-dot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
          height: 12px;
          background-color: #facc15;
          border-radius: 50%;
          box-shadow: 0 0 10px rgba(250, 204, 21, 0.8);
          z-index: 2;
          animation: center-pulse 2s ease-in-out infinite;
        }

        .wave-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid #facc15;
          opacity: 0;
          animation: ripple-expand 2s ease-out infinite;
        }

        .wave-ring-delay {
          animation-delay: 1s;
        }
      }

      // 新增图标层
      .map-icons-layer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 20;  // 确保在波纹点之上
      }

      .map-icon {
        position: absolute;
        transform: translate(-50%, -50%);
        pointer-events: none;

        img {
          width: 34px;   // 控制图标尺寸
          height: 34px;
          object-fit: contain;
          display: block;
        }
      }
    }

    .right-box {
      background: #ffffff;
      border-radius: 8px;
      padding: 32px 28px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      width: 80%;

      .distribution-title {
        display: flex;
        align-items: center;
        gap: 12px;

        .title-icon {
          width: 32px;
          height: 32px;
          object-fit: contain;
        }

        .title-text {
          font-size: 34px;
          font-weight: 600;
          color: #ff962f;
          line-height: 1.2;
        }
      }

      .content-box {
        padding: 0 60px;
      }

      .stats-row {
        position: relative;
        display: block;
        width: 100%;
        margin: 8px 0 40px;

        .stats-bg {
          width: 100%;
          height: auto;
          display: block;
          border-radius: inherit;
        }

        .stats-content {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px;
          box-sizing: border-box;

          .stat-item {
            font-size: 52.33px;
            font-weight: 700;
            color: #333333;
            line-height: 1.2;
            padding: 0 40px;
            margin-top: 20px;

            span {
              font-size: 28px;
              font-weight: 500;
              margin-left: 4px;
            }
          }

          .stats-line {
            width: 2px;
            height: 50%;
            background-color: #ffffff;
            flex-shrink: 0;
            margin-top: 20px;
          }
        }
      }

      .section-title {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        margin-top: 25px;
        margin-bottom: 20px;
        position: relative;
        padding-left: 12px;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 20px;
          background-color: #1d7e29;
          border-radius: 2px;
        }
      }

      .org-list {
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        line-height: 1.6;
        text-align: justify;
      }
    }

    @media (max-width: 1400px) {
      padding: 0 100px;
    }

    @media (max-width: 1024px) {
      padding: 0 50px;
    }

    @media (max-width: 768px) {
      padding: 0 20px;

      .map-content {
        flex-wrap: wrap;
        gap: 20px;
      }

      .left-box,
      .right-box {
        flex: 0 0 100%;
        width: 100%;
      }

      // 移动端点的大小适配
      .left-box {
        .blink-dot {
          width: 7px;
          height: 7px;
        }
        .wave-point {
          width: 9px;
          height: 9px;
          .center-dot {
            width: 9px;
            height: 9px;
          }
        }
      }
    }
  }

  // ========== 新增动画关键帧 ==========
  @keyframes blink-animation {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.4; transform: scale(0.8); }
  }
  @keyframes pulse-ring {
    0% { transform: scale(0.5); opacity: 0.8; }
    100% { transform: scale(2); opacity: 0; }
  }
  @keyframes ripple-expand {
    0% { width: 12px; height: 12px; opacity: 0.8; border-width: 2px; }
    100% { width: 60px; height: 60px; opacity: 0; border-width: 1px; }
  }
  @keyframes center-pulse {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
      background-color: #facc15;
      box-shadow: 0 0 8px rgba(250, 204, 21, 0.6);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.2);
      background-color: #ffb347;
      box-shadow: 0 0 16px rgba(250, 204, 21, 0.9);
    }
  }
}
</style>
<style>
/* 清理旧的时间轴样式，只保留必要的全局样式 */
.el-timeline-item__timestamp.is-bottom {
  display: none !important; /* 隐藏，使用新的样式 */
}

.el-timeline-item__node {
  /* 全局节点样式已在scoped中重新定义 */
}

.el-timeline-item__tail {
  display: none !important;
}

.el-timeline-item__content {
  /* 全局内容样式已在scoped中重新定义 */
}

.el-timeline-item {
  /* 全局项目样式已在scoped中重新定义 */
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/companyProfile/CompanyProfile.vue